import { style } from 'typestyle';

const typedStyle = style({
  fontSize: '0.5rem',
});

export default typedStyle;
